import pintrest from '../logos/pintrest.png';
import youtube from '../logos/youtube.png';
import facebook from '../logos/fb.png';
import twitter from '../logos/twitter.png';
import linkedin from '../logos/linkedin.png';
import insta from '../logos/insta.png';
import playstore from '../logos/playstore.png';

export const social = {
    pintrest,
    youtube,
    facebook,
    twitter,
    linkedin,
    insta,
    playstore
};